import {StatCard} from 'shells/metrics/stat-card/stat-card';

interface Props {
    count: number;
    isPrimary: boolean;
}

export function LoadingCards(props: Props) {
    return (
        <>
            {Array.from({length: props.count}, (_, i) => (
                <StatCard
                    key={`loading-${i}`}
                    displayName=''
                    value=''
                    type='text'
                    isLoading={true}
                    isPrimary={props.isPrimary && i === 0}
                />
            ))}
        </>
    );
}
